import { api } from "./api";

export interface Farm {
  id: string;
  name: string;
  // The auto-created home farm. Always present, can be renamed but not deleted.
  isDefault: boolean;
}

interface IFarmBackendResponse {
  id: string;
  name: string;
  isDefault?: boolean;
}

export const listFarms = async (): Promise<Farm[]> => {
  const body = await api.get<{ farms: IFarmBackendResponse[] }>("/api/v1/farms");
  const farms = body.farms ?? [];
  return farms.map((f) => ({
    id: f.id,
    name: f.name,
    isDefault: f.isDefault ?? false,
  }));
};

export const createFarm = async (name: string): Promise<string> => {
  const body = await api.post<{ id: string }>("/api/v1/farms", { name });
  return body.id;
};

export const renameFarm = async (id: string, name: string): Promise<void> => {
  await api.patch(`/api/v1/farms/${id}`, { name });
};

export const deleteFarm = async (id: string): Promise<void> => {
  await api.delete(`/api/v1/farms/${id}`);
};

export const moveFieldsToFarm = async (
  fieldIds: string[],
  farmId: string
): Promise<number> => {
  const body = await api.post<{ updated: number }>(
    "/api/v1/fields/bulk/move-to-farm",
    { fieldIds, farmId }
  );
  return body.updated ?? 0;
};
